
import { Link } from 'react-router-dom';
import { useI18n } from 'src/utils/lni18n';
import LnIcon from 'src/components/LnIcon';
import {  PublishPartViewDataDTO } from '../domain/PublishPartViewDataDTO';
import { CoursePartEditResponseModel } from '../domain/CoursePartEditResponseModel';
import { ClassAndTest } from './Publish';
import classes from './publish.module.scss';
import { IdAndNameAndSelectDto } from 'src/types';

export default function UsedBy(props: { publishData: PublishPartViewDataDTO, 
    excludedTestClasses?: ClassAndTest[],
    checkExcluded?: (checked: boolean, Id: string, te: IdAndNameAndSelectDto) => void,
    part?: CoursePartEditResponseModel   }) {

    const { languageService: t } = useI18n();
    const publishData = props.publishData;
    const part = props.part;
    const excludedTestClasses = props.excludedTestClasses;
    const checkExcluded = props.checkExcluded;


    if (!publishData ) return null;

    return <>


        {publishData.Classes && publishData.Classes.length > 0 &&
            <div className='mb-5'>
                <hr />
                <div className='d-flex'>
                    <div className='flex-fill'>
                        <h3 className='mb-3'>{t.getText("used.by")}</h3>
                        {publishData.Classes.map(c =>
                            <div key={c.Id} className="mb-3">
                                <strong>{c.Name}</strong>
                                <div>{t.getShortDateString(c.StartDate)}&nbsp;&nbsp;&#8594;&nbsp;&nbsp;{t.getShortDateString(c.ClassEndDate)}</div>
                                <div>
                                    {t.getText("course")}:&nbsp;
                                    <Link to={`/course/${c.Course.Id}/general`}>{c.Course.Name}</Link>

                                </div>
                            </div>
                        )
                        }
                    </div>
                    <div className='ms-3 '>
                        <div className='alert alert-danger'>
                            {t.getText("publish.warning")}
                            <LnIcon name="alert" className='icon-small ms-2 mb-2' />
                        </div>


                                {part && checkExcluded && part.NewTests?.length  > 0 && excludedTestClasses && excludedTestClasses.length > 0 && <>
                                    <div className='preserve-white mb-5'>{t.getText("hidden.tests.at.publish.explain")}</div>

                                    <table className='table table-condensed table-striped'>
                                        <thead>
                                            <tr>
                                                <th className='border-0'>
                                                    {t.getText("test")}
                                                </th>
                                                {part.NewTests.map(c => <th className='border-0' key={c.Id}>
                                                    <div title={c.Name} className={`me-3 ${classes.testName}`}>{c.Name}</div>
                                                </th>)}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {excludedTestClasses.map(cl => <tr key={cl.Id}>

                                                <td>{cl.Name}</td>
                                                {cl.Tests.map(te => <td key={te.Id} title={te.Name}>

                                                    <label>
                                                        <input type='checkbox'
                                                            checked={te.Selected}
                                                            onChange={(e) => checkExcluded(e.currentTarget.checked, cl.Id, te)} />&nbsp;&nbsp;{t.getText("hide")}
                                                    </label>
                                                </td>)}
                                            </tr>)}
                                        </tbody>
                                    </table>
                                </>
                                }
                            

                    </div>
                </div>

            </div>}

        {publishData.OtherCourses && publishData.OtherCourses.length > 0 && <div>
            <hr />
            <h3 className='mb-3'>{t.getText("part.of.following.courses")}</h3>
            {publishData.OtherCourses.map(c => <div key={c.Id} className='mb-3'>
                <Link to={`/course/${c.Id}/general`}>{c.Name}</Link>
            </div>)}
        </div>}

    </>



}